<template>
  <div>
    <div class="">
      <img class="mb-4" :src="require('@/assets/sxm-logo-blue.svg')" width="100" height="21" />
      <Hero
        :title="
          $t(
            `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']}.title`
          )
        "
        :text="
          $t(`message.spotlight.sxm['${introKey}'].text`, { duration: hasSxmProgram ? sxmPayload.duration : null })
        "
      ></Hero>
      <SXMVideo class="video-container" :video-id="videoId" product="sxm"></SXMVideo>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const Hero = () => import('@/modules/spotlight/components/Hero.vue');
const SXMVideo = () => import('@/modules/spotlight/components/SpotlightVideoPlayer.vue');

export default {
  name: 'HighlightSiriusXM',
  components: {
    Hero,
    SXMVideo,
  },
  computed: {
    ...mapGetters('spotlight', ['hasSxmProgram', 'sxmPayload']),
    introKey() {
      return this.hasSxmProgram ? 'introProgram' : 'introEquipped';
    },
    videoId() {
      const isEnglish = this.$i18n.locale.includes('en');
      return isEnglish ? 'qbmgEJFKGRw' : 'gY7_deUzhGs';
    },
  },
};
</script>

<style scoped lang="scss">
a {
  font-weight: 500;
  display: block;
  margin-bottom: 24px;
}
.video-container {
  margin-bottom: 32px;
}
</style>
